<template lang="pug">
  .grid.widgets(
    :style="{backgroundColor: background_color, fontFamily: global_font}"
    )
    widget(
      v-for='(widget,index) in widgets'
      :key='index'
      :ref='`widget_${index}`'
      :style='widget.draft_content.styles'
      :widget_index='index'
      :widget='widget'
      :is_edit='true'
      :brand='brand'
      :landing_page='landing_page'
      :retailer='retailer'
      :show_inline_placeholders='show_inline_placeholders'
      :api_base_path='api_base_path'
      :debug_mode='debug_mode'
      :selected_share_id='selected_share_id'
      @delete_widget='delete_widget'
      @edit_widget='edit_widget'
      @move_widget='move_widget'
      @add_widget='add_widget'
      @initial_drag_index='set_drag_index')
</template>

<script>
  // @vue/component
  import widget from '../widget.vue'
  import _ from 'lodash'
  import widget_placeholder from './widget_placeholder.jpg'

  export default {
    name: 'landing_page_grid',
    components: {
      widget
    },
    props: {
      widgets: {
        type: Array,
        required: true,
        default: () => []
      },
      brand: {
        type: Object,
        required: true
      },
      landing_page: {
        type: Object,
        required: false
      },
      retailer: {
        type: Object,
        required: false
      },
      show_inline_placeholders: {
        type: Boolean,
        required: false,
        default: false
      },
      api_base_path: {
        type: String,
        required: true
      },
      debug_mode: {
        type: Boolean,
        required: false,
        default: false
      },
      selected_share_id: {
        type: String,
        required: false
      }
    },
    computed: {
      background_color() {
        if(this.landing_page){
          return this.landing_page.background_color ? this.landing_page.background_color : "#ffffff"
        }
        return "#ffffff"
      },
      global_font() {
        if(this.landing_page){
          return this.landing_page.global_font ? this.landing_page.global_font : "Roboto"
        }
        return "Roboto"
      }
    },
    data() {
      return {
        initial_drag_index: null
      }
    },
    methods: {
      edit_widget(landing_page_widget) {
        this.$emit('widget_edit', landing_page_widget)
      },
      delete_widget(landing_page_widget) {
        this.$emit('widget_delete', landing_page_widget)
      },
      add_widget(data) {
        let widget_index = data.element.getAttribute('widget_index')
        this.$emit('widget_add', { widget_id: event.dataTransfer.getData('widget_id'), widget_index: widget_index })
      },
      move_widget(data) {
        const original_widget = this.widgets.splice(data.event.dataTransfer.getData('widget_index'), 1)[0]
        let widget_index = data.element.getAttribute('widget_index')
        // drop below header
        if (widget_index === "0") widget_index = "1"
        this.widgets.splice(widget_index, 0, original_widget)
        this.$emit('widget_reorder', _.map(this.widgets, (widget) => widget.id))
      },
      set_drag_index(index) {
        this.initial_drag_index = index
      },
      create_drag_image() {
        if (!document.getElementById('drag-image')) {
          let image = document.createElementNS("http://www.w3.org/1999/xhtml","img");
          image.id = 'drag-image'
          image.src = widget_placeholder
          image.height = 0
          document.body.appendChild(image)
        }
      }
    },
    mounted() {
      this.create_drag_image()
    }
  }
</script>
<style lang="scss">
@import '../../../styles/variables_and_mixins';
  .empty-state {
    padding: 20px;
    color: get-color(gray);
    text-align: center;
    i {
      font-size: 5em;
      display: block;
      margin-bottom: 10px;
    }
  }
</style>

<style lang="scss" scoped>
  .drop-zone {
    height: 25px;
  }
  .grid {
    font-family: Arial, Helvetica, sans-serif;
    max-width: 768px;
    margin: 0 auto;
  }
</style>
